import * as React from 'react';
import { FaArrowCircleDown } from 'react-icons/fa';

const ScrollButton = () => {

  const [visible, setVisible] = React.useState(true)

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    const documentH = Math.max(
      document.body.scrollHeight, document.body.offsetHeight,
      document.documentElement.clientHeight, document.documentElement.scrollHeight,
      document.documentElement.offsetHeight) - window.innerHeight;
    if (scrolled > (documentH - 10)) {
      setVisible(false)
    }
    else if (scrolled < documentH) {
      setVisible(true);
    }
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  window.addEventListener('scroll', toggleVisible);

  return (
    <div className='scrollButton'>
      <FaArrowCircleDown onClick={scrollToBottom}
        style={{ display: visible ? 'inline' : 'none' }} />
    </div>
  );
}

export default ScrollButton;